import { Typography } from "@mui/material";
import { RedirectType } from "src/types/apps";

export default function RedirectUri({ redirectURI }: RedirectType) {
	return (
		<Typography variant='body2' color='text.primary'>
			{redirectURI}
		</Typography>
	);
}
